<script>
import Multiselect from 'vue-multiselect';
import UpdateUrlMixin from './mixins/update-url';

export default {
  name: 'FilterListProperty',
  mixins: [UpdateUrlMixin],
  components: { Multiselect },
  props: {
    property: { type: Object, required: false },
    values: { type: Array, required: false },
  },
  data() {
    return { selectedValues: [] };
  },
  computed: {
    name() { return this.property?.name; },
  },
  methods: {
    addPropertyValue(value, propertyId) {
      this.goToModifiedPropertiesURL(propertyId, (values) => {
        if (!values.includes(value)) values.push(value);
        return values;
      });
    },
    deletePropertyValue(value, propertyId) {
      this.goToModifiedPropertiesURL(propertyId, (values) => {
        const index = values.indexOf(value);
        if (index !== -1) values.splice(index, 1);
        return values;
      });
    },
  },
  watch: {
    property: {
      handler() {
        if (!this.property) return;
        this.selectedValues = this.property.selectedValues;
      },
      immediate: true,
    },
  },
};
</script>

<template>
  <div
    v-if="property && values.length > 0"
    class="block bg-gray-diagomics-light py-2 mt-4"
  >
    <div class="text-gray-800 text-sm px-2 pb-2 border-b-2 border-white">
      {{ $t(name.toLowerCase()) }}
    </div>
    <div class="mt-2 px-2">
      <Multiselect v-model="selectedValues"
                    :options="values"
                    :placeholder="$t(name.toLowerCase())"
                    :multiple="true"
                    :allow-empty="true"
                    :select-label="''"
                    :deselect-label="''"
                    @select="addPropertyValue"
                    @remove="deletePropertyValue"
                    :id="property.id"
      >
      </Multiselect>
    </div>
  </div>
</template>
